import { CommonModule } from '@angular/common';
import { Component, effect, Input } from '@angular/core';
import { SvgLoaderComponent } from 'app/components/ui-kit/images/svg-loader/svg-loader.component';
import { AppStateService } from 'app/services/app-state.service';
import { FlightConnectionsService } from 'app/services/flight-connections-services';
import { FlightOptionService } from 'app/services/flight-option-service';
import { TimeAndDateService } from 'app/services/time-and-date-service';
import { UserService } from 'app/services/user.service';

@Component({
  selector: 'app-flight-option-card',
  standalone: true,
  imports: [CommonModule, SvgLoaderComponent],
  templateUrl: './flight-option-card.component.html',
  styleUrl: './flight-option-card.component.scss'
})
export class FlightOptionCardComponent {
  @Input() flightOption: any;
  @Input() showHeader: boolean = true;
  @Input() showSeats: boolean = true;

  isLinkedInConnected: boolean = false;
  linkedInStat: string;

  isReviewed: boolean = false;
  connectionStatus: string | null = null;
  chipText: string | null = null;
  reviewStat: string;

  timezone: string;
  privateName: string;

  constructor(private timeAndDate: TimeAndDateService, private userService: UserService, private connectionsService: FlightConnectionsService, private appState: AppStateService) {
    effect(() => {
      const option = this.appState.agent.selectedOption();
      if (option == null) {
        this.checkForConnections()
      }
    });
  }

  ngOnInit(): void {
    if (!this.flightOption) {
      return;
    }
    this.loadStats();
    this.checkForConnections();
    this.timezone = this.timeAndDate.getTimezoneAbbreviation(this.flightOption.timeZone);
    this.privateName = this.userService.getPrivateName(this.flightOption.creatorDisplayName);
  }

  async loadStats() {
    this.linkedInStat = await this.getLinkedInStat();
    this.reviewStat = await this.getReviewStat();
  }

  async getLinkedInStat() { // TODO: Handle real linkedIn Connections
    this.isLinkedInConnected = Math.random() < 0.7;
    return `${this.flightOption.creatorLinkedInMatrix?.length || 0} Connections`;
  }

  async checkForConnections() {
    if (!this.flightOption) {
      return;
    }
    // TODO: Solve issue where some connections are created straight from chat and wont have the same option ID.
    const status = await this.connectionsService.checkFlightOptionForExistingConnection(this.flightOption.id);
    this.connectionStatus = status;
    switch (status) {
      case 'accepted':
        this.chipText = 'Already Connected';
        break;
      case 'declined':
        this.chipText = 'Declined';
        break;
      case 'requested':
        this.chipText = 'Requested';
        break;
      default:
        this.chipText = null;
    }
  }

  async getReviewStat() { // TODO: handle real review stats
    const { averageRating, totalReviews } = await this.userService.getRatingStats(this.flightOption.creatorId);
    this.isReviewed = totalReviews > 0;
    return `${averageRating.toFixed(1)}/5 (${totalReviews} flight${totalReviews === 1 ? '' : 's'})`;
  }

  l(location) {
    return location.endsWith(', US') ? location.replace(/, US$/, '') : location;
  }

  d(date): string {
    return this.timeAndDate.formatDateToMMDDYY(date);
  }

  t(time): string {
    return this.timeAndDate.formatTimeForTimezone(this.flightOption.timezone, time);
  }

}
